export default __webpack_public_path__ + "static/media/bookos-regular.cef60375.ttf";